import React from 'react';
import './EcommerceWebsiteDevelopment.css';
import { Helmet } from "react-helmet-async";
const features = [
    "Product Catalog & Inventory Management",
    "Shopping Cart & Secure Checkout",
    "Payment Gateway Integration (Razorpay, Stripe, etc.)",
    "Customer Login & Order Tracking",
    "Discount Coupons & Promotions",
    "Admin Dashboard to Manage Products/Orders",
    "Mobile-Friendly Design",
    "SEO & Analytics Integration"
];

const benefits = [
    "24/7 Online Storefront",
    "Wider Customer Reach",
    "Automated Sales Process",
    "Real-Time Inventory Updates",
    "Scalable Platform for Growth",
    "Lower Operating Costs vs. Physical Store",
    "Increased Customer Engagement",
    "Complete Business Control"
];

const useCases = [
    "Retail & Fashion Stores",
    "Electronics & Gadgets",
    "Beauty & Wellness Brands",
    "Grocery & Food Delivery",
    "Digital Product Sellers",
    "Furniture & Home Decor",
    "Books & Education Platforms",
    "Multi-Vendor Marketplaces"
];

const EcommerceWebsiteDevelopment = () => {
    return (
        <div className="ecommerce-container">

            <Helmet>
  <title>E-Commerce Website Development | APTech Solution Gujarat</title>
  <meta 
    name="description" 
    content="We design and develop secure, scalable e-commerce websites with payment gateway integration to grow your online business." 
  />
</Helmet>

            <h1 className="ecommerce-title">E-commerce Website Development</h1>
            <p className="ecommerce-subtitle">
                Sell online with confidence — we build feature-rich, secure, and scalable e-commerce websites tailored to your products and audience.
            </p>

            <section className="ecommerce-section">
                <h2 className="section-heading">What is an E-commerce Website?</h2>
                <p className="ecommerce-paragraph">
                    An e-commerce website allows businesses to showcase products and accept payments online. It includes features like a product catalog, shopping cart, payment integration, and customer management tools.
                </p>
            </section>

            <section className="ecommerce-section">
                <h2 className="section-heading">Core Features</h2>
                <div className="card-grid">
                    {features.map((feature, idx) => (
                        <div className="feature-card" key={idx}>
                            <span className="card-icon">🛒</span>
                            <p>{feature}</p>
                        </div>
                    ))}
                </div>
            </section>

            <section className="ecommerce-section">
                <h2 className="section-heading">Who Needs an E-commerce Site?</h2>
                <div className="card-grid">
                    {useCases.map((item, idx) => (
                        <div className="feature-card" key={idx}>
                            <span className="card-icon">🏪</span>
                            <p>{item}</p>
                        </div>
                    ))}
                </div>
            </section>

            <section className="ecommerce-section">
                <h2 className="section-heading">Benefits of Selling Online</h2>
                <div className="card-grid">
                    {benefits.map((benefit, idx) => (
                        <div className="feature-card" key={idx}>
                            <span className="card-icon">💰</span>
                            <p>{benefit}</p>
                        </div>
                    ))}
                </div>
            </section>

            <section className="cta-box">
                <h3>Start Your Online Store Today</h3>
                <p>Whether you're launching a new brand or upgrading your shop — we’ll help you build an e-commerce website that converts.</p>
                <a href="https://wa.me/919316580274" target="_blank" rel="noopener noreferrer">
                    <button className="cta-button">Request Free Demo</button>
                </a>
              
            </section>
        </div>
    );
};

export default EcommerceWebsiteDevelopment;
